import { api } from './client';
import type {
  EmailClass,
  EmailSequence,
  EmailSequenceStep,
  EmailSequenceLog,
  EmailSequenceTrigger,
  EmailSequenceLogStatus,
} from '@/types';

export interface CreateSequencePayload {
  name: string;
  trigger: EmailSequenceTrigger;
  isActive?: boolean;
  /** WEB-1473: класс письма; не прислали — сервер оставит 'marketing'. */
  emailClass?: EmailClass;
}

export interface UpdateSequencePayload {
  name?: string;
  trigger?: EmailSequenceTrigger;
  isActive?: boolean;
  /** WEB-1473: не прислали — прежний класс письма не меняется. */
  emailClass?: EmailClass;
  /** WEB-2717: галочка «слать после покупки»; не прислали — не меняется. */
  continueAfterPurchase?: boolean;
}

export interface CreateStepPayload {
  subject: string;
  body: string;
  delayHours?: number;
  stepOrder?: number;
}

export interface UpdateStepPayload {
  subject?: string;
  body?: string;
  delayHours?: number;
  stepOrder?: number;
}

export interface LogsQueryParams {
  from?: string;
  to?: string;
  status?: EmailSequenceLogStatus;
}

export const emailSequencesApi = {
  list: (projectId: string) =>
    api.get<EmailSequence[]>(`/projects/${projectId}/email-sequences`),

  get: (projectId: string, id: string) =>
    api.get<EmailSequence>(`/projects/${projectId}/email-sequences/${id}`),

  create: (projectId: string, data: CreateSequencePayload) =>
    api.post<EmailSequence>(`/projects/${projectId}/email-sequences`, data),

  update: (projectId: string, id: string, data: UpdateSequencePayload) =>
    api.patch<EmailSequence>(
      `/projects/${projectId}/email-sequences/${id}`,
      data,
    ),

  delete: (projectId: string, id: string) =>
    api.delete(`/projects/${projectId}/email-sequences/${id}`),

  addStep: (projectId: string, sequenceId: string, data: CreateStepPayload) =>
    api.post<EmailSequenceStep>(
      `/projects/${projectId}/email-sequences/${sequenceId}/steps`,
      data,
    ),

  updateStep: (
    projectId: string,
    sequenceId: string,
    stepId: string,
    data: UpdateStepPayload,
  ) =>
    api.patch<EmailSequenceStep>(
      `/projects/${projectId}/email-sequences/${sequenceId}/steps/${stepId}`,
      data,
    ),

  deleteStep: (projectId: string, sequenceId: string, stepId: string) =>
    api.delete(
      `/projects/${projectId}/email-sequences/${sequenceId}/steps/${stepId}`,
    ),

  getLogs: (projectId: string, sequenceId: string, params?: LogsQueryParams) =>
    api.get<EmailSequenceLog[]>(
      `/projects/${projectId}/email-sequences/${sequenceId}/logs`,
      { params },
    ),

  testSend: (projectId: string, sequenceId: string, email: string) =>
    api.post<{ success: boolean; message: string }>(
      `/projects/${projectId}/email-sequences/${sequenceId}/test-send`,
      { email },
    ),
};
